export default ({ request }) => ({
  mrpInspectionDefectIssuesPageListApi(data = {}) {
    return request({
      url: '/factory/inspection/defectIssues/pageList',
      method: 'post',
      data
    })
  },
  mrpInspectionDefectIssuesSaveApi(data = {}) {
    return request({
      url: '/factory/inspection/defectIssues/save',
      method: 'post',
      data
    })
  },
  mrpInspectionDefectIssuesDetailApi(data = {}) {
    return request({
      url: '/factory/inspection/defectIssues/detail',
      method: 'post',
      data
    })
  },
  mrpInspectionDefectIssuesDelApi(data = {}) {
    return request({
      url: '/factory/inspection/defectIssues/del',
      method: 'post',
      data
    })
  },
  mrpInspectionDefectIssuesGroupApi(data = {}) {
    return request({
      url: '/factory/inspection/defectIssues/issuesGroup/list',
      method: 'post',
      data
    })
  },
})
